import { styled } from '@mui/material/styles';

export const Page = styled('div')`
  min-height: calc(100vh - 96px);
  padding: 20px 12px 32px;
  background: #f5f7fa;
  color: #15213b;
  font-family: Arial, sans-serif;
`;

export const Boundary = styled('section')`
  width: min(480px, 100%);
  margin: 0 auto;
`;

export const ModuleHeading = styled('div')`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 0 0 12px;

  h1 {
    margin: 0;
    font-size: 18px;
    line-height: 1.35;
    font-weight: 700;
  }
`;

export const Steps = styled('ol')`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  padding: 0;
  margin: 0 0 10px;
  list-style: none;
`;

export const Step = styled('li')`
  min-width: 0;

  button {
    width: 100%;
    min-height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 4px 2px;
    border: 0;
    background: transparent;
    color: #65728a;
    font: inherit;
    font-size: 12px;
    cursor: pointer;
  }

  button:disabled {
    cursor: default;
  }

  .number {
    display: inline-grid;
    place-items: center;
    flex: 0 0 22px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #dce1ec;
    color: #65728a;
    font-size: 12px;
    font-weight: 700;
  }

  &.active button {
    color: #3f56e2;
    font-weight: 600;
  }

  &.active .number {
    background: #3f56e2;
    color: #fff;
  }

  &.completed button {
    color: #007e62;
  }

  &.completed .number {
    background: #ecfdf5;
    color: #007e62;
  }

  @media (max-width: 390px) {
    button {
      gap: 4px;
      font-size: 12px;
    }

    .number {
      flex-basis: 20px;
      width: 20px;
      height: 20px;
    }
  }
`;

export const ClientHeader = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 18px;
  border-bottom: 1px solid #dce3f0;
  font-size: var(--v3-body-size, 14px);

  .client-status {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    color: #007d63;
    font-weight: 700;
  }

  .balance {
    display: flex;
    align-items: center;
    gap: 7px;
    color: #10213f;
  }

  .balance strong {
    padding: 4px 10px;
    border: 1px solid #75e2b7;
    border-radius: 999px;
    background: #ecfff6;
    color: #007d63;
    font-size: var(--v3-control-size, 15px);
  }

  @media (max-width: 390px) {
    padding: 11px 14px;

    .balance {
      align-items: flex-end;
      flex-direction: column;
      gap: 2px;
      font-size: 12px;
    }
  }
`;

export const WorkCard = styled('div')`
  --v3-title-size: 20px;
  --v3-body-size: 14px;
  --v3-control-size: 15px;
  --v3-row-height: 48px;
  overflow: hidden;
  border: 1px solid #dce1ec;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(28, 48, 67, 0.07);

  /* Existing screens keep the tested API behaviour; V3 normalises their shell. */
  > div:not([data-v3-client-header]) {
    border: 0;
    border-radius: 0;
    box-shadow: none;
    padding: 18px;
  }

  h2 {
    font-size: var(--v3-title-size);
    line-height: 1.35;
  }

  button {
    min-height: 44px;
    font-size: var(--v3-control-size);
    line-height: 1.35;
  }

  input {
    min-height: 44px;
  }

  @media (max-width: 510px) {
    > div:not([data-v3-client-header]) {
      padding: 16px;
    }
  }
`;

export const DevMarker = styled('div')`
  margin-top: 12px;
  color: #65728a;
  font-size: 12px;
  line-height: 1.4;
`;
